import { Checkbox, TableCell, TableRow } from "@material-ui/core";
import { FolderOpen, InsertDriveFile } from "@material-ui/icons";
import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { addByteUnit, isFolder } from "../../../common/AppUtil";
import {
  fetchChangeFilePrefix,
  fetchChangeSelectedFileInfo,
  selector as fileStoreSelector,
} from "../../../store/FileStore";
import { selector as officeStoreSelector } from "../../../store/OfficeStore";
import useStyles from "../useStyles";

/**
 * FilesTableRowコンポーネント.
 *
 * @return {object} コンポーネント
 */
function FilesTableRow() {
  // スタイル
  const styles = useStyles();

  // Dispatch
  const dispatch = useDispatch();

  const {
    // ファイル情報一覧
    fileInfos,
    // ファイルプレフィックス
    filePrefix,
    // 選択済みファイル情報一覧
    selectedFileInfos,
  } = useSelector(fileStoreSelector);

  const {
    // 選択されている拠点情報
    selectedOfficeInfo,
  } = useSelector(officeStoreSelector);

  // テーブルセルクリック時の処理
  const handleTableCellClick = (fileInfo) => {
    if (!isFolder(fileInfo.fileType)) {
      // ファイル種別がフォルダではない場合は何もしない
      return;
    }
    dispatch(fetchChangeFilePrefix(fileInfo.fileKey));
  };

  // 選択済みファイル情報一覧に含まれているかの判定（true：含まれている、false：含まれていない）
  const isIncludesSelectedFileInfos = (fileInfo) => {
    for (let index = 0; index < selectedFileInfos.length; index++) {
      if (selectedFileInfos[index].fileKey === fileInfo.fileKey) {
        return true;
      }
    }
    return false;
  };

  // チェックボックス変更時の処理
  const handleCheckboxChange = (event, fileInfo) => {
    if (!event || !event.target) {
      return;
    }
    dispatch(
      fetchChangeSelectedFileInfo({
        fileInfo,
        checked: event.target.checked,
      })
    );
  };

  // ファイル or フォルダアイコン
  const fileIcon = (fileInfo) => {
    if (isFolder(fileInfo.fileType)) {
      return <FolderOpen />;
    }
    return <InsertDriveFile />;
  };

  // 最終更新日時を変換
  const formatData = (utcDate) => {
    if (utcDate === "-") {
      return "-";
    }
    const localeDate = new Date(utcDate);

    const year = localeDate.getFullYear().toString().padStart(4, "0");
    const month = (localeDate.getMonth() + 1).toString().padStart(2, "0");
    const day = localeDate.getDate().toString().padStart(2, "0");
    const hour = localeDate.getHours().toString().padStart(2, "0");
    const minute = localeDate.getMinutes().toString().padStart(2, "0");
    const second = localeDate.getSeconds().toString().padStart(2, "0");

    return `${year}/${month}/${day} ${hour}:${minute}:${second}`;
  };

  return !fileInfos || !fileInfos.length ? (
    <TableRow>
      <TableCell />
      <TableCell>-</TableCell>
      <TableCell>-</TableCell>
      <TableCell>-</TableCell>
    </TableRow>
  ) : (
    fileInfos.map((fileInfo) => (
      <TableRow key={fileInfo.fileName} hover={isFolder(fileInfo.fileType)}>
        <TableCell padding="checkbox">
          <Checkbox
            color="primary"
            // filePrefixが「selectedOfficeInfo.serialNumber/DOWNLOAD/」で始まっていない場合
            // かつ、フォルダの場合はチェックボックスを無効化にする
            disabled={
              !filePrefix.startsWith(
                `${selectedOfficeInfo.serialNumber}/DOWNLOAD/`
              ) && isFolder(fileInfo.fileType)
            }
            // filePrefixが「selectedOfficeInfo.serialNumber/DOWNLOAD/」で始まっていない場合
            // かつ、フォルダの場合はチェックボックスを未確定状態にする
            indeterminate={
              !filePrefix.startsWith(
                `${selectedOfficeInfo.serialNumber}/DOWNLOAD/`
              ) && isFolder(fileInfo.fileType)
            }
            checked={isIncludesSelectedFileInfos(fileInfo)}
            onChange={(event) => handleCheckboxChange(event, fileInfo)}
          />
        </TableCell>
        <TableCell onClick={() => handleTableCellClick(fileInfo)}>
          <div className={styles.flexStart}>
            <div className={styles.fileNameIcon}>{fileIcon(fileInfo)}</div>
            <div className={`${styles.fileNameText} ${styles.wordBreak}`}>
              {fileInfo.fileName}
            </div>
          </div>
        </TableCell>
        <TableCell onClick={() => handleTableCellClick(fileInfo)}>
          {formatData(fileInfo.lastModified)}
        </TableCell>
        <TableCell onClick={() => handleTableCellClick(fileInfo)}>
          {addByteUnit(fileInfo.fileType, fileInfo.fileSize)}
        </TableCell>
      </TableRow>
    ))
  );
}

export default FilesTableRow;
